<template>
  <main role="UserLog">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header mb-5">
            <h4 class="card-title">User Log</h4>
            <div class="row">
              <div class="col-md-12">
                <date-range-picker
                  style="width: 100%; font-size: 14px"
                  :appendToBody="appendToBody"
                  v-model="dateRange"
                  @update="changeType"
                  :locale-data="{ format: 'yyyy/mm/dd' }"
                >
                </date-range-picker>
              </div>
              <div class="col-md-6">
                 <!-- <select
                  name=""
                  class="select-filter"
                  id=""
                  v-model="filterType"
                  @change="changeType"
                >
                  <option :value="ft.slug" v-for="ft in filters" :key="ft.name">
                    {{ ft.name }}
                  </option>
                </select>                -->
              <!-- <vue-select class="ml-3" :options="filters"  @input="changeType" v-model="filterType" :reduce="name => name.slug" label="name" placeholder="Filter Pemberitahuan..." :clearable="clearable"/> -->

                <!-- <div class="select-filter-icon">
                  <i class="fa fa-bars"></i>
                </div> -->
              </div>
            </div>
          </div>
          <!-- placeholders -->
          <div class="col-md-12">
            <div class="card p-3 placeholderCard" v-for="i in 3" :key="i">
              <content-placeholders :animated="false">
                <content-placeholders-heading :img="true" />
                <content-placeholders-text :lines="1" />
              </content-placeholders>
            </div>
          </div>
          <!-- end placeholders -->
          <!-- Card Notif -->
          <div v-for="(notif, $index) in notifications" :key="$index">
            <div class="col-md-12">
              <div class="card p-4 notifCard">
                <div class="media">
                  <img :src="notif.icon" class="mr-3 img-fluid" width="40px" />
                  <div class="media-body">
                    <h5 class="mt-2 font-weight-bold mb-0">
                      {{ notif.title }}
                    </h5>
                    <p class="text-muted" style="font-size: 12px">
                      {{ notif.text }}
                    </p>
                    <div class="mb-2">
                     

                      <div :class="` userAgent${$index}`">
                        <p
                          v-if="!notif.ip"
                          class="text-muted"
                          style="font-size: 12px"
                        >
                          Ip Address: None
                        </p>
                        <p v-else class="text-muted" style="font-size: 12px">
                          Ip Address: {{ notif.ip }}
                        </p>
                        <p class="text-muted" style="font-size: 12px">
                          {{ notif.userAgent }}
                        </p>
                      </div>
                    </div>

                    <small class="text"
                      >{{ notif.dateAt }} / {{ notif.createdAt }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <infinite-loading
            :identifier="infiniteId"
            @infinite="infiniteHandler"
          >
            <div slot="spinner">
              <div class="col-md-12">
                <div class="card p-3" v-for="i in 10" :key="i">
                  <content-placeholders :animated="false">
                    <content-placeholders-heading :img="true" />
                    <content-placeholders-text :lines="1" />
                  </content-placeholders>
                </div>
              </div>
            </div>
            <div slot="no-more">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body text-muted" style="font-size: 13px">
                    No More Data
                  </div>
                </div>
              </div>
            </div>
            <div slot="no-results">
              <div class="col-md-12">
                <div class="card p-3 notifCard">
                  <div class="media">
                    <div class="media-body py-4 text-center">
                      <img
                        class="img-fluid mb-4"
                        style="opacity: 0.3"
                        width="60px"
                        src="@/assets/upload/notif_mailbox.png"
                        alt=""
                      />
                      <br>
                      <h5 class="mt-2 mb-2 ">Tidak Ada data</h5>
                      <span class="text-muted">You dont have more data to review</span>
                      <p class="text-muted" style="font-size: 12px"></p>
                      <small class="text"></small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </infinite-loading>
           
          <!-- end card notif -->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";
import axios from "axios";

import $ from "jquery";

import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import { convert } from "/src/helper.js";
Vue.component("pagination", require("laravel-vue-pagination"));

export default {
  components: {
    InfiniteLoading,
    DateRangePicker,
  },
  data() {
    return {
      notifications: [],
      filters: [],
      page: 1,
      dateRange: {
        startDate: `${new Date()}`,
        endDate: `${new Date()}`,
      },
      clearable:false,
      infiniteId: +new Date(),
      appendToBody:true
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      // user: "user",
      notif: "notif",
    }),
  },
  methods: {
    infiniteHandler($state) {
      // const params = `?page=${page}`;
      let notifUrl = `user/log/seller?limit=5`;
      const dateRange = `${convert(this.dateRange.startDate)}-${convert(
        this.dateRange.endDate
      )}`;
      axios
        .get(notifUrl, {
          params: {
            page: this.page,
            filter_type: this.filterType,
            filter_date: dateRange,
          },
        })
        .then(({ data }) => {
          // console.log(data.data)
          $(".placeholderCard").hide();
        //   this.filters = data.data.filters[0].items;
          // this.notifications = data.data.items;
          // console.log(data.data)
          if (data.data.items.length) {
            this.page += 1;
            this.notifications.push(...data.data.items);
            $state.loaded();
          } else {
            $state.complete();
          }
        })
    },
    changeType() {
      this.page = 1;
      this.notifications = [];
      this.infiniteId += 1;
    },
  },
  mounted: function () {
    $(".reportrange-text").css("border", "none");
    $(".reportrange-text").css("border-bottom", "1px solid black");
    $(".reportrange-text").css("border-radius", "0px");
    $(".reportrange-text").addClass("mt-1");
    $(".glyphicon").addClass('mr-2')
    $('.openscenter').css('left', '50%')
    
  },
};
</script>

<style scoped>


.select-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  /* background: url('/src/assets/upload/up-arrow.png')
    no-repeat right #ddd; */
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #818181;
  color: #464545;
  padding: 0px 0px 0px 30px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

/* For IE <= 11 */
.select-filter::-ms-expand {
  display: none;
}

select option {
  /* margin: 40px; */
  background-color: #fff;
  color: #fff;
  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4); */
}

.input-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 0.3px solid #818181;
  /* color: #464545; */
  padding: 0px 0px 0px 10px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
}

/* For IE <= 11 */
.input-filter::-ms-expand {
  display: none;
}

.select-filter-icon {
  position: absolute;
  top: 8px;
  left: 10px;
  width: 30px;
  height: 36px;
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.select-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.select-filter:hover ~ .select-filter-icon,
.select-filter:focus ~ .select-filter-icon {
  background-color: white;
  /* border-color: #464545; */
}

.input-filter:hover ~ .input-filter-icon,
.input-filter:focus ~ .input-filter-icon {
  background-color: white;
  /* border-color: #464545; */
  border: 0;
}

.select-filter:hover ~ .select-filter-icon svg.icon,
.select-filter:focus ~ .select-filter-icon svg.icon {
  fill: #464545;
}
</style>